import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  FilterList,
  DataTable,
  DataTableProps,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import { MoneyCell } from './components/MoneyCell';

import { getCostsList, ISummary } from '@/modules/cash/services/costs-v2';


export default /*#__PURE__*/_defineComponent({
  __name: 'Costs',
  setup(__props) {

const router = useRouter();

const hasError = ref(false);
const isLoading = ref(false);

const selectedYear = ref('');
const availableYears = ref<number[] | null>(null);
const summary = ref<ISummary[] | null>(null);

const tableStatus = computed(() => {
  if (hasError.value) return 'error';
  if (isLoading.value) return 'loading';

  return 'default';
});

const columns: DataTableProps.Column[] = [
  {
    label: 'Mês',
    type: 'chip',
    getter: ({ month }) => ({
      text: month.formatted
    })
  },
  {
    label: 'Pendente inicial',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: ({ initialPending }) => ({
      text: initialPending
    })
  },
  {
    label: 'Custos',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: ({ provisionated }) => ({
      text: provisionated
    })
  },
  {
    label: 'Pago',
    component: MoneyCell,

    align: DataTableProps.Align.Right,
    getter: ({ paid }) => ({
      text: paid
    })
  },
  {
    label: 'Pendente final',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: ({ finalPending }) => ({
      text: finalPending
    })
  },
  {
    label: 'Status',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: ({ status }) => ({
      isChip: true,
      text: status.description,
      chipColor: status.color
    })
  },
  {
    type: 'icon',
    getter: () => ({
      icon: 'EA0170',
      ariaLabel: 'Ver detalhes'
    })
  }
];

const yearsOptions = computed(() => {
  return availableYears.value?.map(year => {
    return {
      label: String(year),
      value: String(year)
    };
  });
});

function onBack() {
  router.push({ name: 'home' });
}

async function onChange() {
  await fetchCostsList();
}

function onRowClick(value: ISummary) {
  router.push({
    name: 'costsDetails',
    params: { year: selectedYear.value, month: String(value.month.value) }
  });
}

async function fetchCostsList() {
  try {
    hasError.value = false;
    isLoading.value = true;

    const data = await getCostsList(selectedYear.value);

    availableYears.value = data.availableYears;
    summary.value = data.summary;
    selectedYear.value = String(data.currentYear);
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  await fetchCostsList();
});

return { __sfc: true,router, hasError, isLoading, selectedYear, availableYears, summary, tableStatus, columns, yearsOptions, onBack, onChange, onRowClick, fetchCostsList, NavBar, Heading, FilterList, DataTable, HelperViewStatus, BackButton, ShowMoneyToggleButton }
}

})